import axios from 'axios';
import React, { useState, createContext, useMemo, useEffect } from 'react';

export const BeneficiaryContext = createContext();

const BeneficiaryContextProvider = (props) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadGroupBeneficiaries = async (groupId) => {
    const response = await axios.get(
      `https://secret-ridge-31139.herokuapp.com/api/group/${groupId}/beneficiary/lists`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data.data;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadGroups = async () => {
    setLoading(true);
    const response = await axios.get(
      'https://secret-ridge-31139.herokuapp.com/api/group/lists',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const submit = async (groupId, csvFile) => {
    const file = csvFile;
    const formData = new FormData();
    formData.append('beneficiaryImport', file);
    try {
      await axios.post(
        `https://secret-ridge-31139.herokuapp.com/api/group/${groupId}/beneficiary/create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let mounted = true;
    loadGroups().then((res) => {
      if (mounted) {
        setGroups(res);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      submit,
      token,
      loadGroupBeneficiaries,
      groups,
      loading,
    }),
    [submit, token, loadGroupBeneficiaries, groups, loading],
  );
  return (
    <BeneficiaryContext.Provider value={value}>
      {props.children}
    </BeneficiaryContext.Provider>
  );
};

export default BeneficiaryContextProvider;
